import { useEffect } from "react";

/**
 * Hook that scrolls to the top of the page when the component mounts.
 * should only be used on page level components on pages where we are okay with it not remembering scroll position through
 * react router's scroll restoration feature..
 */
const useScrollToTopOfPageOnMount = (): void => {
	useEffect(() => {
		const scrollToTop = () => {
			const mainBodyContent = document.getElementById("main-body-content");
			const htmlElement = document.documentElement;
			const bodyElement = document.body;

			if (mainBodyContent) {
				mainBodyContent.scrollTop = 0;
			}

			htmlElement.scrollTop = 0;
			bodyElement.scrollTop = 0;
			window.scrollTo(0, 0);
		};

		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				scrollToTop();
			});
		});
	}, []);
};

export default useScrollToTopOfPageOnMount;
